import { useSyncExternalStore } from 'react'

// Tiny path router: /, /p/:id, /p/:id/werkstatt. Back/forward work through popstate.
const listeners = new Set()
const notify = () => listeners.forEach((l) => l())
window.addEventListener('popstate', notify)

export function navigate(path, { replace = false } = {}) {
  if (path === window.location.pathname) return
  window.history[replace ? 'replaceState' : 'pushState'](null, '', path)
  notify()
}

const subscribe = (l) => { listeners.add(l); return () => listeners.delete(l) }
export const usePath = () => useSyncExternalStore(subscribe, () => window.location.pathname)

export function matchRoute(path) {
  let m
  if ((m = path.match(/^\/p\/([a-z0-9]+)\/werkstatt\/?$/))) return { page: 'werkstatt', id: m[1] }
  if ((m = path.match(/^\/p\/([a-z0-9]+)\/?$/))) return { page: 'plan', id: m[1] }
  return { page: 'projects' }
}
